import { render, staticRenderFns } from "./OfferTerms.vue?vue&type=template&id=71284a4a&"
import script from "./OfferTerms.vue?vue&type=script&lang=js&"
export * from "./OfferTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports